/* Glas-Header: schaltet beim Scrollen auf die feste Leiste um */
(function () {
  'use strict';

  function init() {
    var hero = document.querySelector('[data-lr-hero]');
    if (!hero) return;

    document.body.classList.add('lr-has-hero');

    /* Video nur, wenn es dem Geraet zumutbar ist: bei reduzierter Bewegung,
       Datensparmodus oder langsamer Verbindung bleibt das Standbild. */
    var video = hero.querySelector('video');
    if (video) {
      var sparsam = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var conn = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
      if (conn && (conn.saveData || /^(slow-2g|2g|3g)$/.test(conn.effectiveType || ''))) sparsam = true;
      if (sparsam) {
        try { video.pause(); } catch (e) {}
        video.removeAttribute('autoplay');
        Array.prototype.forEach.call(video.querySelectorAll('source'), function (s) { s.parentNode.removeChild(s); });
        video.removeAttribute('src');
        try { video.load(); } catch (e) {}
      }
    }

    var header = document.querySelector('.shopify-section-group-header-group');
    if (header) {
      var setHeight = function () {
        var wrapper = header.querySelector('.header-wrapper') || header;
        document.documentElement.style.setProperty('--lr-header-height', wrapper.offsetHeight + 'px');
      };
      setHeight();
      window.addEventListener('resize', setHeight);
    }

    var threshold = 0;
    var ticking = false;

    function measure() {
      threshold = Math.max(80, Math.round(hero.offsetHeight * 0.6));
    }

    function update() {
      document.body.classList.toggle('lr-header-stuck', window.scrollY > threshold);
      ticking = false;
    }

    measure();
    update();

    window.addEventListener('scroll', function () {
      if (!ticking) {
        window.requestAnimationFrame(update);
        ticking = true;
      }
    }, { passive: true });

    window.addEventListener('resize', function () {
      measure();
      update();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
